import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useAuth from "../../hooks/AuthHook";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { Dropdown } from 'primereact/dropdown';
import { useNavigate, useSearchParams } from "react-router-dom";
import OrderDetailSidebar from "./OrderDetailSidebar";
import { Tag } from 'primereact/tag';

const currencyIntl = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' });

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const [ orders, setOrders ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ selectedToView, setSelectedToview ] = useState();
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    useEffect(() => {
        setLoading(false);
        setLoading(true);
        api.get(`orders?page=${page}&limit=${limit}`).then(({ data }) => {
            setOrders(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }, [page, limit]);

    const actions = order => (
        <>
            <Button icon="pi pi-eye" title="Visualizar" onClick={() => setSelectedToview(order)}/>
        </>
    );

    const titleButtons = (
        <Button label="Adicionar" onClick={() => navigate('./new')}/>
    );

    const statusColumn = (order) => {
        switch (order.status) {
            case 'ACCEPTED': return <Tag severity="success" value="APROVADO"/>;
            case 'WAITING': return <Tag severity="warning" value="PENDENTE"/>;
            case 'REJECTED': return <Tag severity="info" value="CANCELADO"/>;
        }
    }

    return (
        <div>
            <PageTitle title="Pedidos" subtitle="Realize pedidos" end={titleButtons}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={orders} selectionMode="single" emptyMessage="Nada encontrado">
                        <Column field="client.commercialName" header="Cliente"/>
                        <Column body={o => o.items.length} header="Produtos"/>
                        <Column body={o => new Date(o.createdAt).toLocaleString()} header="Data"/>
                        <Column body={statusColumn} header="Status"/>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
            <OrderDetailSidebar order={selectedToView} onHide={() => setSelectedToview(null)}/>
        </div>
    );
}